// extracted by mini-css-extract-plugin
export default {"root":"XrV_xjAXA7jOgw0Bstn5","element-title":"X46EgkVx5knKW7rXrJfV","elementTitle":"X46EgkVx5knKW7rXrJfV"};